module.exports = __webpack_public_path__ + "img/save_btn.61e6282d.png";